export default "__VITE_ASSET__Gv$6IOFF__"